import styled, { css } from 'styled-components';
import { ButtonV2, InputV2 } from '@getgrover/ui';

export const StyledForm = styled.form`
    ${({ isHidden }) =>
        isHidden &&
        css`
            visibility: hidden;
            height: 0;
        `}
`;

export const FormRow = styled.div`
    display: flex;
`;

export const FormRowItem = styled.div`
    width: 50%;
    &:nth-child(2) {
        margin-left: 40px;
    }
`;

export const Input = styled(InputV2)`
    margin-bottom: 24px;

    ${({ hasError }) =>
        hasError &&
        css`
            > div {
                border-bottom-color: #f44336;
            }

            label {
                color: #f44336;
            }
        `}
`;

export const SubmitButton = styled(ButtonV2)`
    margin-top: 24px;
`;

export const ErrorText = styled.p`
    ${({ theme }) => theme.typography.TinyParagraph};
    color: ${({ theme }) => theme.colors.Color1_75};
`;

export const iframeInputStyleObject = ({ mode }) => ({
    width: '100%',
    'max-height': '100%',
    'box-sizing': 'border-box',
    color: mode === 'dark' ? '#ffffff' : '#333333',
    'font-family': '"helvetica neue", helvetica, arial, sans-serif',
    'word-spacing': '-0.2px',
    'letter-spacing': 'normal',
    'font-size': '16px',
    'line-height': '27px',
    'font-weight': '500',
    background: 'transparent',
    position: 'relative',
    top: '16px',
    border: 'none',
    outline: 'none',
    transition: 'color .2s ease',
});

export const Hint = styled.div`
    ${({ theme }) => theme.typography.TinyParagraph};
    display: flex;
    width: 100%;
    padding: 8px 16px 8px 8px;
    color: ${({ theme }) => theme.colors.secondary};
    background-color: ${({ theme }) => theme.colors.secondaryBackground};
    border-radius: 8px;

    svg {
        margin-right: 8px;
        flex: 0 32px;
    }
`
